import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { bool, func } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import {
  FAQ,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  SectionContactUs,
  SectionHelpGettingStarted,
  SectionHelpArticles,
} from '../../components';
import { IconBookmark } from '../../components';

import css from './FAQPage.module.css';
import { sendCallMeBackRequest } from '../../ducks/callMeBack.duck';

const FAQPage = props => {
  const {
    currentUser = null,
    currentUserHasListings = false,
    onSubmitCallMeBack,
    submitInProgress,
    callMeBackError,
    callMeBackSuccess,
  } = props;

  return (
    <StaticPage
      title="Help"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HelpPage',
        description: 'Help for localtrailerhire.com.au',
        name: 'Help page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.helpTitle}>How can we help?</h1>
                <SectionHelpGettingStarted />
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.helpTitle}>Frequently asked questions</h1>

                <h2 className={css.navTitle}>Select a topic</h2>
                <nav className={css.contentNav}>
                  <ul className={css.navList}>
                    {!!currentUserHasListings && (
                      <li>
                        <IconBookmark className={css.icon} size={'small'} />
                        <a href="#managingBookings">
                          <FormattedMessage id="FAQ.managingBookingTitle" />
                        </a>
                      </li>
                    )}
                    <li>
                      <IconBookmark className={css.icon} size={'small'} />
                      <a href="#listing">
                        <FormattedMessage id="FAQ.listingTitle" />
                      </a>
                    </li>
                    <li>
                      <IconBookmark className={css.icon} size={'small'} />
                      <a href="#hiring">
                        <FormattedMessage id="FAQ.hirersTitle" />
                      </a>
                    </li>
                    <li>
                      <IconBookmark className={css.icon} size={'small'} />
                      <a href="#premium">Premium listings</a>
                    </li>
                    <li>
                      <IconBookmark className={css.icon} size={'small'} />
                      <a href="#managingAccount">
                        <FormattedMessage id="FAQ.managingAccountTitle" />
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </li>

            {!!currentUserHasListings && (
              <>
                <div id="managingBookings"></div>
                <li className={css.faqSection}>
                  <div className={css.sectionContent}>
                    <h2>
                      <FormattedMessage id="FAQ.managingBookingTitle" />
                    </h2>
                    <FAQ category={'managingBookings'} />
                  </div>
                </li>
              </>
            )}

            <div id="listing"></div>
            <li className={css.faqSection}>
              <div className={css.sectionContent}>
                <h2>
                  <FormattedMessage id="FAQ.listingTitle" />
                </h2>
                <FAQ category={'listing'} />
              </div>
            </li>

            <div id="hiring"></div>
            <li className={css.faqSection}>
              <div className={css.sectionContent}>
                <h2>
                  <FormattedMessage id="FAQ.hirersTitle" />
                </h2>
                <FAQ category={'hiring'} />
              </div>
            </li>

            <div id="premium"></div>
            <li className={css.faqSection}>
              <div className={css.sectionContent}>
                <h2>Premium listings</h2>
                <div className={css.premiumSubsections}>
                  <div className={css.premiumSubsection}>
                    <h3>Premium Monthly</h3>
                    <FAQ category={'premium-monthly'} />
                  </div>
                  <div className={css.premiumSubsection}>
                    <h3>Premium Pay As You Go</h3>
                    <FAQ category={'premium-payg'} />
                  </div>
                  <div className={css.premiumSubsection}>
                    <h3>General Premium Features</h3>
                    <FAQ category={'premium'} />
                  </div>
                </div>
              </div>
            </li>

            <div id="managingAccount"></div>
            <li className={css.faqSection}>
              <div className={css.sectionContent}>
                <h2>
                  <FormattedMessage id="FAQ.managingAccountTitle" />
                </h2>
                <FAQ category={'managingAccount'} />
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionHelpArticles />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionContactUs
                  onSubmitCallMeBack={onSubmitCallMeBack}
                  submitInProgress={submitInProgress}
                  callMeBackError={callMeBackError}
                  callMeBackSuccess={callMeBackSuccess}
                  currentUser={currentUser}
                  sectionTitle="Any more questions?"
                />
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

FAQPage.propTypes = {
  currentUserHasListings: bool,
  currentUser: propTypes.currentUser,
  onSubmitCallMeBack: func.isRequired,
  submitInProgress: bool.isRequired,
  callMeBackError: propTypes.error,
};

const mapStateToProps = state => {
  const { currentUser, currentUserHasListings } = state.user;
  const { submitInProgress, callMeBackError, callMeBackSuccess } = state.callMeBack;

  return {
    currentUser,
    currentUserHasListings,
    submitInProgress,
    callMeBackError,
    callMeBackSuccess,
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmitCallMeBack: (name, phoneNumber, reasonForCallBack, otherInfo, email) =>
    dispatch(sendCallMeBackRequest(name, phoneNumber, reasonForCallBack, otherInfo, email)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(FAQPage);
